import { HierarchyContextProps, IHierarchyActionSetSubscriptionStatus } from "../interface";

/**
 * Updates the hierarchy subscription status.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-subscription-status action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchySubscriptionStatus = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetSubscriptionStatus,
): HierarchyContextProps => ({
  ...state,
  isSubscribed: action.isSubscribed,
});
